// Types
interface OfWarConfig {
  disableDevtool: boolean
  offers: Array<{
    value: number
    link: string
    params: boolean
  }>
  backRedirect: {
    time: number
    start: boolean
    params: boolean
    href: string
  }
}

declare global {
  interface Window {
    ofwar: (config: OfWarConfig) => void
    clickFn: (value: number) => void
  }
}

let isInitialized = false
let initializationPromise: Promise<void> | null = null

export const initializeGodOfWar = async (): Promise<void> => {
  if (isInitialized) {
    return Promise.resolve()
  }

  if (initializationPromise) {
    return initializationPromise
  }

  const userId = localStorage.getItem('quiz_user_id')
  const baseUrl = 'https://pagamento.misteriosdodestino.com/p/mapa-numerologico-pitagorico-686U1EPP8'

  // Get existing UTM parameters from URL
  const currentUrl = new URL(window.location.href)
  const params = new URLSearchParams()

  // Add coupon code
  params.append('cupom', 'QUIZ')

  // Copy all existing UTM parameters
  for (const [key, value] of currentUrl.searchParams.entries()) {
    if (key.toLowerCase().startsWith('utm_')) {
      params.append(key, value)
    }
  }

  // Add user ID as utm_id if available
  if (userId && !params.has('utm_id')) {
    params.append('utm_id', userId)
  }

  const checkoutUrl = `${baseUrl}?${params.toString()}`

  initializationPromise = new Promise((resolve) => {
    const script = document.createElement('script')
    script.src = 'https://cloud-thoththesage.s3.sa-east-1.amazonaws.com/godofwar-1.1.0.js'
    script.async = true

    script.onload = () => {
      window.ofwar({
        disableDevtool: false,
        offers: [
          {
            value: 1,
            link: checkoutUrl,
            params: true
          }
        ],
        backRedirect: {
          time: 0,
          start: false,
          params: false,
          href: ""
        }
      })
      isInitialized = true
      resolve()
    }

    document.head.appendChild(script)
  })

  return initializationPromise
}